import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Checkmark = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='m15.625 10.242-4.5 5.512-2-2.004'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M21.625 12.748c0 4.981-4.03 9.02-9 9.02s-9-4.039-9-9.02c0-4.982 4.03-9.02 9-9.02 4.97-.001 9 4.038 9 9.02'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.625 2.725c-5.523 0-10 4.487-10 10.023s4.477 10.022 10 10.022 10-4.487 10-10.022-4.477-10.023-10-10.023m3.58 7.993A.753.753 0 0 0 16.1 9.66a.75.75 0 0 0-1.056.106l-3.975 4.87-1.414-1.418a.75.75 0 0 0-1.06 0 .753.753 0 0 0 0 1.063l2 2.005a.75.75 0 0 0 1.11-.056z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
